import NavigateBackWizardStep from "../../components/navigateBackWizardStep";
import { useHistory } from "react-router-dom";
import { useWizard } from "react-use-wizard";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import HealthReminderForDietitianBooking from "../healthinfo/HealthReminderForDietitianBooking";
import DietInfoReminderForDietitianBooking from "../dietInfo/DietInfoReminderForDietitianBooking";

import createPersistedState from "use-persisted-state";
import HealthReminderForDietitianBooking2 from "../healthinfo/HealthReminderForDietitianBooking2";

const useProfileState = createPersistedState("profile");

function SelectHCProviderStep({ attendDetail, selectClinic, setRecDoctor }) {
  const { goToStep, nextStep } = useWizard();
  const history = useHistory();
  const { search } = useLocation();
  const location = useLocation();
  const { t } = useTranslation();
  const [profile] = useProfileState();

  const [isHealthReminderOpen, setIsHealthReminderOpen] = useState(false);

  const [isHealthReminder2Open, setIsHealthReminder2Open] = useState(false);
  const [isDietitianReminderOpen, setIsDietitianReminderOpen] = useState(false);

  const [selectedHCProvider, setSelectedHCProvider] = useState("doctor");

  const [isDietInfoFilledRecently, setIsDietInfoFilledRecently] =
    useState(false);

  const [healthInfoUpdateDismissed, setHealthInfoUpdateDismissed] =
    useState(false);

  useEffect(() => {
    // TODO: The following logic isn't obvious and is deeply embeded
    // lift this logic
    const isReschedule = new URLSearchParams(search).get("reschedule");
    const isOnline = new URLSearchParams(search).get("online");
    const isDietitian = new URLSearchParams(search).get("isDietitian");

    //this is to indicate if health info filled recentle during booking flow
    const isDietInfoRecentlyFilled = new URLSearchParams(search).get(
      "dietInfoFilled"
    );
    setIsDietInfoFilledRecently(isDietInfoRecentlyFilled === "true");

    // if user coming for reschedule
    if (Boolean(isReschedule) && isOnline === "true" && isDietitian == "true") {
      selectClinic("CC000007");
      setRecDoctor({ drId: "DT000006", drName: "Dietitian" });
      goToStep(3);
    } else if (isDietInfoRecentlyFilled) {
      selectClinic("CC000007");
      setRecDoctor({ drId: "DT000006", drName: "Dietitian" });
      goToStep(3);
    } else if (Boolean(isReschedule) && isOnline === "true") {
      selectClinic("CC000000");
      goToStep(3);
    } else if (Boolean(isReschedule)) {
      goToStep(2);
    } else {
    }
  }, []);

  useEffect(() => {
    const selectedHCProviderParam = new URLSearchParams(search).get(
      "hcprovider"
    );
    if (selectedHCProviderParam) {
      setSelectedHCProvider(selectedHCProviderParam);
    }
  }, []);

  const handleClick = () => {
    nextStep();
  };

  const updateSelectedHCProvider = (HCProvider) => {
    setSelectedHCProvider(HCProvider);

    // Preserve existing query params
    const params = new URLSearchParams(location.search);
    params.set("hcprovider", HCProvider);

    // Update URL with new query param
    history.replace({
      pathname: location.pathname,
      search: params.toString(),
    });
  };

  return (
    <>
      <NavigateBackWizardStep
        clickHandler={() => history.push("/my-appointments")}
        title={t("appointment.DOCTOR.topHeading")}
      />
      <div className="body_content py-5">
        <div className="inner_body ">
          <ul className="list-unstyled list_specialist">
            <li>
              <a
                href="#"
                onClick={(e) => {
                  updateSelectedHCProvider("doctor");
                  setRecDoctor({
                    drId: profile?.doctorId,
                    drName: profile?.doctorName,
                  });
                  handleClick();
                }}
                className={selectedHCProvider === "doctor" ? "active" : ""}
                data-bs-toggle={attendDetail === null ? "modal" : ""}
                data-bs-target="#modal_doctor"
              >
                {t("appointment.DOCTOR.doctor1")}
              </a>
            </li>
            <li>
              <a
                href="#"
                className={selectedHCProvider === "dietitian" ? "active" : ""}
                onClick={() => {
                  updateSelectedHCProvider("dietitian");
                  if (!isDietInfoFilledRecently && !healthInfoUpdateDismissed) {
                    if (!profile?.healthInfoFilled) {
                      setIsHealthReminderOpen(true);
                    } else {
                      setIsHealthReminder2Open(true);
                    }
                  } else if (profile?.dietInfoFilled === false) {
                    setIsDietitianReminderOpen(true);
                  } else {
                    setRecDoctor({ drId: "DT000006", drName: "Dietitian" });
                    selectClinic("CC000007");
                    goToStep(3);
                  }
                }}
                // data-bs-toggle="modal"
                // data-bs-target="#modal_dietitian"
              >
                {t("appointment.DOCTOR.doctor2")}
              </a>
            </li>
            <li>
              <a href="#" data-bs-toggle="modal" data-bs-target="#modal_physio">
                {t("appointment.DOCTOR.doctor3")}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="custom_modal modal fade text-center" id="modal_doctor">
        <div className="modal-dialog d-flex align-items-center top-0">
          <div className="modal-content">
            <div className="modal-header border-bottom-0">
              <button
                id="modal_doctor"
                type="button"
                className="btn-close btn-dark-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="content_modal text-start p-2">
                <h3 className="maintitle maintitle_txt_color_black text-center pb-3">
                  {t("appointment.DOCTOR.modal")}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="custom_modal modal fade text-center" id="modal_dietitian">
        <div className="modal-dialog d-flex align-items-center top-0">
          <div className="modal-content">
            <div className="modal-header border-bottom-0">
              <button
                id="modal_dietitian"
                type="button"
                className="btn-close btn-dark-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="content_modal text-start p-2">
                <h3 className="maintitle maintitle_txt_color_black text-center">
                  {t("appointment.DOCTOR.dietitian")}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="custom_modal modal fade text-center" id="modal_physio">
        <div className="modal-dialog d-flex align-items-center top-0">
          <div className="modal-content">
            <div className="modal-header border-bottom-0">
              <button
                id="modal_physio"
                type="button"
                className="btn-close btn-dark-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="content_modal text-start p-2">
                <h3 className="maintitle maintitle_txt_color_black text-center">
                  {t("appointment.DOCTOR.physiotherapy")}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isHealthReminderOpen && (
        <HealthReminderForDietitianBooking
          isHealthInfoFilled={profile?.healthInfoFilled}
          show={isHealthReminderOpen}
          dismiss={() => setIsHealthReminderOpen(false)}
        />
      )}
      {isHealthReminder2Open && (
        <HealthReminderForDietitianBooking2
          show={isHealthReminder2Open}
          dismiss={() => {
            setIsHealthReminder2Open(false);
            setHealthInfoUpdateDismissed(true);
            setRecDoctor({ drId: "DT000006", drName: "Dietitian" });
            selectClinic("CC000007");

            if (profile?.dietInfoFilled) {
              goToStep(3);
            } else {
              setIsDietitianReminderOpen(true);
            }
          }}
        />
      )}
      {isDietitianReminderOpen && (
        <DietInfoReminderForDietitianBooking
          show={isDietitianReminderOpen}
          dismiss={() => setIsDietitianReminderOpen(false)}
        />
      )}
    </>
  );
}

export default SelectHCProviderStep;
